<div class="store-hierarchy" id="divStoreHierarchySelector">
  <div class="store-hierarchy__breadcrumb" id="divStoreHierarchyBreadcrumb">
    <span class="store-hierarchy__crumb">{{ hierarchy?.companyName }}</span>
    <ng-container *ngIf="selectedRegion">
      <mat-icon class="store-hierarchy__crumb-sep">chevron_right</mat-icon>
      <span class="store-hierarchy__crumb">
        {{ selectedRegion.id === unassignedRegionId ?
        ("organization.create.section_4.glide_section.product_management.real_time_stock_availability.unassigned_stores"
        | translate) : selectedRegion.name }}
      </span>
    </ng-container>
    <ng-container *ngIf="selectedGroup">
      <mat-icon class="store-hierarchy__crumb-sep">chevron_right</mat-icon>
      <span class="store-hierarchy__crumb store-hierarchy__crumb--current">
        {{ selectedGroup.id === unassignedGroupId ?
        ("organization.create.section_4.glide_section.product_management.real_time_stock_availability.unassigned_stores"
        | translate) : selectedGroup.name }}
      </span>
    </ng-container>
  </div>

  <div class="store-hierarchy__columns">
    <div class="store-hierarchy__column">
      <div class="store-hierarchy__column-header">
        {{"organization.create.section_4.glide_section.product_management.real_time_stock_availability.trading_regions"
        | translate }}
      </div>
      <div class="store-hierarchy__column-scroll">
        <div class="store-hierarchy__empty" id="divStoreHierarchyNoRegions" *ngIf="!regions.length">
          {{"organization.create.section_4.glide_section.product_management.real_time_stock_availability.no_stores"
          | translate }}
        </div>
        <button
          type="button"
          class="store-hierarchy__row store-hierarchy__row--region"
          *ngFor="let region of regions"
          [class.store-hierarchy__row--active]="region.id === selectedRegionId"
          (click)="onRegionClick(region.id)"
        >
          <span class="store-hierarchy__row-name">
            {{ region.id === unassignedRegionId ?
            ("organization.create.section_4.glide_section.product_management.real_time_stock_availability.unassigned_stores"
            | translate) : region.name }}
          </span>
          <mat-icon class="store-hierarchy__row-chevron">chevron_right</mat-icon>
        </button>
      </div>
    </div>

    <div class="store-hierarchy__column">
      <div class="store-hierarchy__column-header">
        {{"organization.create.section_4.glide_section.product_management.real_time_stock_availability.store_groups"
        | translate }}
      </div>
      <div class="store-hierarchy__column-scroll">
        <div
          class="store-hierarchy__empty"
          id="divStoreHierarchyNoStoreGroups"
          *ngIf="selectedRegion && !storeGroups.length"
        >
          {{"organization.create.section_4.glide_section.product_management.real_time_stock_availability.no_store_groups"
          | translate }}
        </div>
        <button
          type="button"
          class="store-hierarchy__row store-hierarchy__row--group"
          *ngFor="let group of storeGroups"
          [class.store-hierarchy__row--active]="group.id === selectedGroupId"
          (click)="onGroupClick(group.id)"
        >
          <span class="store-hierarchy__row-name">
            {{ group.id === unassignedGroupId ?
            ("organization.create.section_4.glide_section.product_management.real_time_stock_availability.unassigned_stores"
            | translate) : group.name }}
          </span>
          <mat-icon class="store-hierarchy__row-chevron">chevron_right</mat-icon>
        </button>
      </div>
    </div>

    <div class="store-hierarchy__column store-hierarchy__column--stores">
      <div class="store-hierarchy__store-header">
        <mat-form-field class="store-hierarchy__filter" appearance="outline">
          <input
            matInput
            id="inputStoreHierarchyFilter"
            [value]="filterText"
            (input)="onFilterChange($any($event.target).value)"
            [placeholder]="'organization.create.section_4.glide_section.product_management.real_time_stock_availability.filter_stores' | translate"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <button
          type="button"
          class="store-hierarchy__select-all"
          id="btnStoreHierarchySelectAll"
          [disabled]="!visibleStores.length"
          (click)="onSelectAllToggle()"
        >
          {{ (allVisibleSelected ?
          "organization.create.section_4.glide_section.product_management.real_time_stock_availability.deselect_all"
          :
          "organization.create.section_4.glide_section.product_management.real_time_stock_availability.select_all")
          | translate }}
        </button>
      </div>
      <div class="store-hierarchy__column-scroll">
        <div
          class="store-hierarchy__empty"
          id="divStoreHierarchyNoStores"
          *ngIf="selectedGroup && !visibleStores.length"
        >
          {{ (groupHasNoStores ?
          "organization.create.section_4.glide_section.product_management.real_time_stock_availability.no_stores"
          :
          "organization.create.section_4.glide_section.product_management.real_time_stock_availability.no_matching_stores")
          | translate }}
        </div>
        <mat-checkbox
          *ngFor="let store of visibleStores"
          class="store-hierarchy__store"
          [checked]="isSelected(store.id)"
          [disabled]="isLocked(store.id)"
          (change)="onStoreToggle(store.id, $event.checked)"
        >
          {{ store.name }}
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
